import PropTypes from 'prop-types'

import theme from 'theme'

export const height = theme.fontSizes[6]

export const validityCheck = (validityType, color) => (props) => {
  const colorChoice = theme.colors[color][0]
  return props[validityType]
    ? {
        borderColor: colorChoice,
        color: colorChoice,
        '&:focus-within': {
          borderColor: colorChoice,
          color: colorChoice
        }
      }
    : {}
}

export const InputContainer = ({
  disabled,
  noRightRadius,
  noLeftRadius,
  noMargin,
  subtext,
  isValid,
  isInvalid,
  maxWidth,
  ...rest
}) => {
  return (
    <div
      css={{
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        justifyContent: 'center',
        height: theme.fontSizes[6],
        borderRadius: theme.borderRadius[0],
        ...(noLeftRadius && {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          marginLeft: -1
        }),
        ...(noRightRadius && {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        }),
        backgroundColor: disabled ? theme.colors.gray[0] : 'white',
        border: theme.border.base,
        color: theme.colors.steel[1],
        marginBottom: !noMargin && !subtext && theme.space[4],
        '&:focus-within': {
          borderColor: isInvalid ? theme.colors.red[0] : theme.colors.blue[0],
          '& label': {
            color: theme.colors.blue[0],
            ...validityCheck('isValid', 'green')({ isValid }),
            ...validityCheck('isInvalid', 'red')({ isInvalid }),
            opacity: 1
          },
          color: theme.colors.blue[0],
          zIndex: 1
        },
        maxWidth: maxWidth
      }}
      {...rest}
    />
  )
}

InputContainer.defaultProps = {
  maxWidth: '100%'
}

InputContainer.propTypes = {
  disabled: PropTypes.bool,
  noRightRadius: PropTypes.bool,
  noLeftRadius: PropTypes.bool,
  noMargin: PropTypes.bool,
  subtext: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isValid: PropTypes.bool,
  isInvalid: PropTypes.bool,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}
